import type { HTMLAttributes } from 'react';

/** Raised card (§4.4): surface-2 + 1px border-strong, radius 4px, no shadow. */
export function Card({ className = '', selected, interactive, ...rest }: HTMLAttributes<HTMLDivElement> & { selected?: boolean; interactive?: boolean }) {
  return (
    <div
      className={[
        'rounded border bg-surface-2 transition-colors duration-fast ease-machine',
        selected ? 'border-accent bg-accent-tint' : 'border-border-strong',
        interactive ? 'hover:border-border-interactive hover:bg-surface-3' : '',
        className,
      ].join(' ')}
      {...rest}
    />
  );
}
